import { EvolutionGraphData } from 'modules/project_management/components/charts/EvolutionChart/getEvolutionTransformedData'

export const mockSkeletonData: EvolutionGraphData[] = [
  {
    x: 0,
    y: 30,
    title: '18',
  },
  {
    x: 1,
    y: 30,
    title: '19',
  },
  {
    x: 2,
    y: 120,
    title: '20',
  },
  {
    x: 3,
    y: 120,
    title: '21',
  },
  {
    x: 4,
    y: 200,
    title: '22',
  },
  {
    x: 5,
    y: 250,
    title: '23',
  },
  {
    x: 6,
    y: 400,
    title: '24',
  },
]
